module.exports = __webpack_public_path__ + "img/right-arrow-1.0c39b102.svg";